import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { videoShape } from '@gameday/components/Play/play/playResults/PlayVideo';
import { VideoWrapper } from '../atbat.style.js';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';

const AtBatVideo = ({
    highlights,
    highlightClickHandler
}) => {
    const { title, duration, id, templateUrl, slug, playbacks } = highlights;

    const VideoPlayerCom = useMemo(() => (
        <VideoPlayer
            title={title}
            duration={duration}
            playbackContainerId={`atbat-video-${id}`}
            id={id}
            showMetaInfo={true}
            templateUrl={templateUrl}
            slug={slug}
            showTitle={true}
            handlers={{ onClick: highlightClickHandler }}
            width={'100%'}
            playbacks={playbacks}
            playerContext={'Gameday: Play Detail'}
        />
    ), [title, duration, id, templateUrl, slug, highlightClickHandler]);

    return (
        templateUrl ? <VideoWrapper>{VideoPlayerCom}</VideoWrapper> : null
    );
};

AtBatVideo.propTypes = {
    highlights: PropTypes.shape(videoShape),
    isLoading: PropTypes.bool,
    gamePk: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    highlightClickHandler: PropTypes.func,
    deviceInteraction: PropTypes.object
};

export default AtBatVideo;
